export const markNotificationAsRead = (notifications, notificationId) => {
  if (!notificationId) {
    return notifications
  }

  return notifications.map(a => parseInt(a.notification_id) === parseInt(notificationId) ? {...a, read: true} : a)

}